import { useEffect } from 'react';

export function lsRead<T = string>(key: string): T | undefined {
  if (typeof window === 'undefined') return undefined;
  try {
    const raw = window.localStorage.getItem(key);
    return raw != null ? (JSON.parse(raw) as T) : undefined;
  } catch {
    return undefined;
  }
}

export function lsWrite<T>(key: string, value: T) {
  if (typeof window === 'undefined') return;
  try {
    window.localStorage.setItem(key, JSON.stringify(value));
  } catch {
    // ignore quota or privacy errors
  }
}

export function lsRemove(key: string) {
  if (typeof window === 'undefined') return;
  try {
    window.localStorage.removeItem(key);
  } catch {
    // ignore quota or privacy errors
    }
}

export const PERSIST_KEYS = {
  sortBy: 'tg-home.sortBy',
  sortOrder: 'tg-home.sortOrder',
  searchQuery: 'tg-home.q',
  aiSearch: 'tg-home.ai',
  pageProducts: 'tg-home.page.products',
  pageAccounts: 'tg-home.page.accounts',
}


export function usePersistToLocalStorage<T>(key: string, value: T) {
  useEffect(() => {
    lsWrite(key, value);
  }, [key, value]);
}
